// Angular imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Service imports
import { HelperService } from '../../../../_services/shared-services/helper.service';

// Model imports
import { FileInfoDisplayResultDto } from '../../../../_models/file-info-display-result-dto';

@Component({
    selector: 'app-transaction-attachments',
    templateUrl: './transaction-attachments.component.html',
    styleUrls: ['./transaction-attachments.component.scss']
})
export class TransactionAttachmentsComponent {
    @Input() visible = false;
    @Input() attachmentData: FileInfoDisplayResultDto[] = [];
    @Output() onAttachmentsClose = new EventEmitter<boolean>();

    loadingVisible = false;
    iconClose: string = IconConstants.CLOSE;

    constructor(private readonly helperService: HelperService) {}

    onShown(e: any): void {
        e.component.repaint();
    }

    onHidden(): void {
        this.visible = false;
        this.attachmentData = null;
        this.onAttachmentsClose.emit(false);
    }

    getFileIconByExtension(file: FileInfoDisplayResultDto): string {
        const fileName = file.fileName;
        return this.helperService.getFileIconByExtension(fileName);
    }

    onPopClose(): void {
        this.onHidden();
    }

    onDownloadClick(event: any): void {
        this.downloadFile(event.downloadUrl, event.fileName);
    }

    private downloadFile(fileURL: string, fileName: string): void {
        this.helperService.downloadFileUsingUrl(fileURL, fileName);
    }
}
